<template>
	<div>
		<nav-bar></nav-bar>
		<div class="container-fluid">
			<router-view />
		</div>
		<footer-bar class="mt-5"></footer-bar>
	</div>
</template>

<script>
import NavBar from '@/components/layout/NavBar.vue';
import FooterBar from '@/components/layout/FooterBar.vue'
export default {
	components: {
		NavBar,
		FooterBar
	},
	created() {
		this.$store.dispatch('tryLogin');
	},
	watch: {
		didAutoLogout(curValue, oldValue) {
			if (curValue && curValue !== oldValue) {
				this.$router.replace('/');
			}
		},
	},
	computed: {
		didAutoLogout() {
			return this.$store.getters.didAutoLogout;
		},
	},
};
</script>

<style>
#app {
	font-family: 'Graduate', cursive;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

#nav {
	padding: 30px;
}

#nav a {
	font-weight: bold;
	color: #2c3e50;
}

#nav a.router-link-exact-active {
	color: #42b983;
}

body {
	font-family: 'Graduate', cursive;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}
</style>
